import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden bg-primary-500">
      <div className="pointer-events-none absolute -top-24 right-0 w-[400px] h-[400px] rounded-full bg-white/10 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 -left-16 w-[360px] h-[360px] rounded-full bg-white/5 blur-3xl"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-white mb-4 animate-on-scroll">
          Votre prochain soin peut être votre première cotation avec CotIdel.
        </h2>
        <p className="text-base md:text-lg text-white/80 mb-9 animate-on-scroll">
          Décrivez. CotIdel analyse. Vous cotez.
        </p>
        <Link
          to="/app"
          className="inline-flex items-center justify-center gap-2 bg-white text-primary-700 hover:bg-white/90 font-bold px-10 py-4 rounded-md text-base transition-all duration-200 cursor-pointer whitespace-nowrap animate-on-scroll"
        >
          <i className="ri-arrow-right-line text-lg"></i>
          ESSAYER COTIDEL
        </Link>
        <p className="mt-6 text-xs text-white/70 animate-on-scroll">
          Sans carte bancaire · Zéro stockage de données patient
        </p>
      </div>
    </section>
  );
}